import { Component, DestroyRef, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AuthenticationService, AuthToken } from './services/authentication.service';

import { ShellComponent } from './shell/shell.component';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [ShellComponent, RouterOutlet]
})
export class AppComponent {
  private destroyRef = inject(DestroyRef);
  currentUser: AuthToken | null;

  constructor(
    private authenticationService: AuthenticationService,
  ) {
    this.authenticationService.token$.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(x => {
      this.currentUser = x;
    });
  }

}
